module.exports = "/_next/static/images/f252e244c765df7b2a431736ff06d123-row-3-transfer.svg";